<!-- body wrapper  -->
<div class="body-wrapper">

    <!-- ==========page banner ========== -->
    <div class="page-ban">
        <div class="page-ban-inner">
            <div class="container">
                <div class="page-content">
                    <h2 class="page-title">
                        Career
                    </h2>
                    <div class="page-url">
                        <a href="index-2.html" class="old-page">Home </a> /
                        <p>Career</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!-- ==========page banner end ====== -->
    <!-- ============Career ======== -->
    <div class="contact cpy-8">
        <div class="container">
            <div class="row mb-5">
                <div class="col-md-12 mb-4">
                    <div class="form-content">
                        <h2 class="form-title">
                            Apply Online
                        </h2>
                        <p>
                            Please add your details in the form below and attach your CV. We will get back to you as
                            soon as possible
                        </p>

                        <div class="contact-form mt-4">
                            <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
                                <div class="row">
                                    <div class="col-sm-6 my-2">
                                        <div class="input-container">
                                            <input id="first-name" class="form-control" type="text" pattern=".+"
                                                formControlName="first_name" required />
                                            <label class="label px-2" for="first-name">First Name</label>
                                            <div *ngIf="submitted && con['first_name'].errors"
                                                class="abs-error text-danger">
                                                <div *ngIf="con['first_name'].errors['required']">First Name is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 my-2">
                                        <div class="input-container">
                                            <input id="Last-name" class="form-control" type="text" pattern=".+"
                                                formControlName="last_name" required />
                                            <label class="label px-2" for="Last-name">Last Name</label>
                                            <div *ngIf="submitted && con['last_name'].errors"
                                                class="abs-error text-danger">
                                                <div *ngIf="con['last_name'].errors['required']">Last Name is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 my-2">
                                        <div class="input-container">
                                            <input id="email" class="form-control" type="email" pattern=".+" required
                                                formControlName="email" />
                                            <label class="label px-2" for="email">Your Email</label>
                                            <div *ngIf="submitted && con['email'].errors" class="abs-error text-danger">
                                                <div *ngIf="con['email'].errors['required']">Email is required</div>
                                                <div *ngIf="con['email'].errors['pattern']">Please enter a valid email
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 my-2">
                                        <div class="input-container">
                                            <input id="phone" class="form-control" type="text" pattern=".+" required
                                                formControlName="phone" (keypress)="numberOnly($event)" />
                                            <label class="label px-2" for="phone">Phone Number</label>
                                            <div *ngIf="submitted && con['phone'].errors" class="abs-error text-danger">
                                                <div *ngIf="con['phone'].errors['required']">
                                                    Phone number is required
                                                </div>
                                                <div *ngIf="con['phone'].errors['minlength']">
                                                    Minimum 10 numbers required
                                                </div>
                                                <div *ngIf="con['phone'].errors['maxlength']">
                                                    Maximum 10 numbers required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-sm-12 my-2">
                                        <div class="input-container">
                                            <select id="position" class="form-control px-2" formControlName="position">
                                                <option value="">Select Job Applying For</option>
                                                <ng-container *ngFor="let opc of jobOption;">
                                                    <option value="{{opc?.id}}">{{opc?.text | titlecase}}</option>
                                                </ng-container>
                                            </select>
                                            <div *ngIf="submitted && con['position'].errors"
                                                class="abs-error text-danger">
                                                <div *ngIf="con['position'].errors['required']">Position is required</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-sm-12 my-2">
                                        <div class="input-container">
                                            <!-- <input id="cv" class="form-control" type="text" pattern=".+" required
                                                formControlName="cv" (keypress)="numberOnly($event)" /> -->
                                            <input class="form-control" type="file" pattern=".+" required
                                                formControlName="cv" (change)="onFileSelected($event)" />
                                            <!-- <label class="label px-2" for="cv">Upload CV</label> -->
                                            <div *ngIf="submitted && con['cv'].errors" class="abs-error text-danger">
                                                <div *ngIf="con['cv'].errors['required']">
                                                    CV is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 my-2">
                                        <div class="input-container">
                                            <textarea name="brief" id="brief" class="form-control" rows="5" required
                                                formControlName="brief"></textarea>
                                            <label class="label px-2" for="brief">Brief Profile</label>
                                            <div *ngIf="submitted && con['brief'].errors" class="abs-error text-danger">
                                                <div *ngIf="con['brief'].errors['required']">Brief Profile is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 mt-3">
                                        <button type="submit" class="custom-btn">Send
                                            Message</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ============Career end======== -->
</div>
<!-- body wrapper end -->